interface Props {
  size?: number
  color?: string
}

export const LoadingSpinner = ({ size = 32, color = "#9ca3af" }: Props) => {
  return (
    <div
      className="animate-spin rounded-full border-2 border-t-transparent"
      style={{
        width: size,
        height: size,
        borderColor: color,
        borderTopColor: "transparent"
      }}
    />
  )
}
